import React from "react";
import ReactCountryFlag from "react-country-flag";
import { getCountryName } from "../../utils";

// Country presentation is consistent everywhere (§12): flag + full name by
// default, flag + ISO-3-ish short code where space is tight.
// `code` is the ISO 3166-1 alpha-2 stored on Player.nationality.
const CountryLabel = ({ code, variant = "full", className = "" }) => {
  if (!code) {
    return <span className={`text-sm text-muted ${className}`}>—</span>;
  }

  const name = getCountryName(code);

  return (
    <span className={`inline-flex items-center gap-2 ${className}`} title={name}>
      <ReactCountryFlag
        countryCode={code}
        svg
        style={{ width: "1.25em", height: "1.25em", borderRadius: "2px" }}
        aria-label={name}
      />
      {variant === "full" && <span className="text-sm">{name}</span>}
      {variant === "compact" && (
        <span className="text-sm font-medium">{code}</span>
      )}
    </span>
  );
};

export default CountryLabel;
